module.exports = __webpack_public_path__ + "img/stickers-quittance-loyer.7108dcb2.jpg";